import { render, staticRenderFns } from "./Registers.vue?vue&type=template&id=1a79444f&scoped=true&lang=pug&"
import script from "./Registers.vue?vue&type=script&lang=js&"
export * from "./Registers.vue?vue&type=script&lang=js&"
import style0 from "./Registers.vue?vue&type=style&index=0&id=1a79444f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a79444f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VChip,VForm,VIcon,VProgressCircular,VSpacer})
